import { apiRequest } from "../../util/apiUtils";


export const categoryListData = async (params) => {
  try {
    const res = await apiRequest("get", "common/categoryList", {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};